<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="border-0 mx-auto container-xl">
      <div class="title-area">
        <h1 class="page-title h2 mb-2">Tutorials</h1>
      </div>
      <BaseTable
        id="tutorials"
        ref="tutorials"
        hover
        :items="tutorials"
        :fields="fields"
        @row-clicked="viewtutorial"
      >
        <template v-slot:cell(tutorial_heading)="data">
          <fa-icon icon="film" class="me-2" />
          {{ data.item.tutorial_heading }}
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-flex justify-content-end" @click.stop>
            <BaseDropdown right class="ms-2">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <a class="dropdown-item" @click.prevent="viewtutorial(data.item);">
                View
              </a>
            </BaseDropdown>
          </div>
        </template>
      </BaseTable>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import BaseTable from './base/BaseTable.vue'
import BaseDropdown from './base/BaseDropdown.vue'

const fields = [
  { key: 'tutorial_heading', label: 'Tutorial', sortable: true, thClass: 'text-left text-start', tdClass: 'text-left text-start' },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button', thClass: 'text-end', tdClass: 'text-end' }
]

export default {
  name: 'Tutorials',
  components: {
    Navbar,
    Breadcrumb,
    BaseTable,
    BaseDropdown
  },
  data: function () {
    return {
      tutorials: [],
      fields
    }
  },
  created () {
    this.tutorials_get()
  },
  methods: {
    tutorials_get () {
      this.$store.dispatch('tutorials_fetch')
        .then((resp) => {
          this.tutorials = resp.data.result
        })
    },
    viewtutorial (item) {
      this.$store.dispatch('tutorial_setcurrent', { tutorial_id: item.id })
        .then(() => {
          this.$router.push('/tutorial')
        })
    }
  }
}
</script>
<style>
</style>
